import { isEmpty } from 'lodash';

import { AppointmentReceptionService } from '@dreryk/egabinet-appointment-frontend-api';

import { StyledFlex, StyledMargin, Text } from '@dreryk/react-components';

import { ReceptionServiceListHeader } from '../../../../shared/ReceptionServiceListHeader';
import { ReceptionServiceListEmptyPlaceholder } from '../../../../shared/ReceptionServiceListEmptyPlaceholder';

import { StyledHexColorBar, StyledReceptionServicePriceText } from './ReceptionServiceList.styled';

type ReceptionServiceListProps = {
   readonly receptionServices: AppointmentReceptionService[];
};

export const ReceptionServiceList = (props: ReceptionServiceListProps): JSX.Element => {
   return (
      <section>
         <StyledMargin left={24}>
            <ReceptionServiceListHeader />
         </StyledMargin>
         {isEmpty(props.receptionServices) ? (
            <StyledMargin left={24}>
               <ReceptionServiceListEmptyPlaceholder />
            </StyledMargin>
         ) : (
            <StyledFlex direction={'column'} gap={'4px'}>
               {props.receptionServices.map((receptionService) => {
                  const hexColor = receptionService.color?.toString() ?? 'transparent';

                  return (
                     <StyledFlex
                        key={receptionService.receptionServiceId}
                        gap={'16px'}
                        justifyContent={'space-between'}
                     >
                        <StyledFlex gap={'16px'} alignItems={'flex-start'}>
                           <StyledFlex>
                              <StyledHexColorBar testId={'color'} color={hexColor} />
                           </StyledFlex>
                           <Text testId={'receptionServiceName'}>{receptionService.name}</Text>
                        </StyledFlex>
                        <StyledReceptionServicePriceText
                           testId={'price'}
                           min={receptionService.minPrice}
                           max={receptionService.maxPrice}
                        />
                     </StyledFlex>
                  );
               })}
            </StyledFlex>
         )}
      </section>
   );
};
